export default __webpack_public_path__ + "static/SiemensProgress-Regula-master-1a863126c750f2fb79b19f21e467808b.woff";